var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42871 5.00007H18.5716M6.42871 5.00007V4.28578C6.42871 3.33858 6.80499 2.43018 7.47476 1.7604C8.14453 1.09063 9.05294 0.714355 10.0001 0.714355C10.9473 0.714355 11.8557 1.09063 12.5255 1.7604C13.1953 2.43018 13.5716 3.33858 13.5716 4.28578V5.00007M7.85728 7.85721V15.7144M12.143 7.85721V15.7144M3.57157 5.00007H16.4287V17.8572C16.4287 18.2361 16.2782 18.5995 16.0103 18.8674C15.7424 19.1353 15.379 19.2858 15.0001 19.2858H5.00014C4.62126 19.2858 4.2579 19.1353 3.98999 18.8674C3.72208 18.5995 3.57157 18.2361 3.57157 17.8572V5.00007Z",
    stroke: "#036CE5",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.d5050d9c.svg";
export { ForwardRef as ReactComponent };